











import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    "bulk-action-stats": () =>
      import("@/components/app/admin/automation/bulkActionStats.vue"),
    "bulk-action-details": () =>
      import("@/components/app/admin/automation/bulkActionDetails.vue")
  }
})
export default class ClientBulkActionOverview extends Vue {}
